import React from 'react'
import { masks, onlyNumbers } from 'util/mask'

import { MaskedField, MaskedFieldProps } from '../final-form/MaskedField'

export function CnsField(props: MaskedFieldProps) {
  return <MaskedField mask={masks.cns} parse={onlyNumbers} {...props} />
}
